var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.16664,
    cy: 4.7618,
    rx: 3.78261,
    ry: 3.78261,
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16664 13.8053C1.16562 13.5394 1.22509 13.2767 1.34055 13.0372C1.70287 12.3125 2.72461 11.9285 3.57244 11.7546C4.18389 11.6241 4.80378 11.5369 5.42751 11.4937C6.58229 11.3922 7.74374 11.3922 8.89852 11.4937C9.52219 11.5374 10.1421 11.6246 10.7536 11.7546C11.6014 11.9285 12.6232 12.2763 12.9855 13.0372C13.2177 13.5255 13.2177 14.0923 12.9855 14.5806C12.6232 15.3415 11.6014 15.6893 10.7536 15.856C10.1429 15.9919 9.52274 16.0815 8.89852 16.1241C7.95863 16.2038 7.01434 16.2183 6.07244 16.1676C5.85504 16.1676 5.6449 16.1676 5.42751 16.1241C4.80563 16.082 4.18788 15.9924 3.57968 15.856C2.72461 15.6893 1.71012 15.3415 1.34055 14.5806C1.22568 14.3383 1.16627 14.0734 1.16664 13.8053Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3c542ccc8b1b10138ae7fb524ed4e18e.svg";
export { ForwardRef as ReactComponent };